export default __webpack_public_path__ + "static/media/dashboardLogo.82df6f70.png";